// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"398177ff","453":"e92042a9","760":"4b94ee8a"}[chunkId] + ".chunk.js";
};